import React from "react";
import { useStoreSelector } from "store/hooks";
import { selectParticipantEntityById } from "store/domain-data/participant/participant";
import { selectParticipantTypeEntityById } from "store/domain-data/participant-type/participantType";
import ParticipantCannotRemoveInformationDialog from "components/ParticipantCannotRemoveInformationDialog/ParticipantCannotRemoveInformationDialog";
import { useDialog } from "hooks/useDialog";
import ParticipantTypeTagStatic from "../ParticipantTypeTag/ParticipantTypeTagStatic";

type Props = {
  participantId: number;
  participantTypeId: number;
  readOnly?: boolean;
};

const ParticipantCardParticipantTypeTag: React.FC<Props> = ({ participantId, participantTypeId, readOnly = false }) => {
  const {
    isDialogOpen: isLockInfoDialogOpen,
    closeDialog: closeLockInfoDialog,
    openDialog: openLockInfoDialog,
  } = useDialog();

  const participant = useStoreSelector((state) => selectParticipantEntityById(state, participantId));
  const participantType = useStoreSelector((state) => selectParticipantTypeEntityById(state, participantTypeId));

  const isLocked = React.useMemo(() => {
    if (!participant || !participantType) {
      return false;
    }

    // Mandatory or required roles are locked
    if (participantType.mandatory || participantType.required) {
      return true;
    }

    // Otherwise not locked
    return false;
  }, [participant, participantType]);

  // The only function of clicking tag is to show the lock info dialog
  const isClickable = React.useMemo(() => {
    if (readOnly) {
      return false;
    }

    return isLocked;
  }, [isLocked, readOnly]);
  const handleClickTag = React.useCallback(() => {
    if (!isClickable) {
      return;
    }

    openLockInfoDialog();
  }, [isClickable, openLockInfoDialog]);

  if (!participant || !participantType) {
    return null;
  }

  return (
    <React.Fragment>
      <ParticipantTypeTagStatic
        displayName={participantType.displayName}
        isClickable={isClickable}
        isLocked={isLocked}
        disabled={participant.isDeleted}
        onClick={handleClickTag}
        data-participant-type-name={participantType.name}
      />

      <ParticipantCannotRemoveInformationDialog
        participantTypeDisplayNames={participantType.displayName}
        isOpen={isLockInfoDialogOpen}
        onClose={closeLockInfoDialog}
      />
    </React.Fragment>
  );
};

export default ParticipantCardParticipantTypeTag;
